import { render, staticRenderFns } from "./orderMaterialPreview.vue?vue&type=template&id=775fd553&scoped=true&"
import script from "./orderMaterialPreview.vue?vue&type=script&lang=js&"
export * from "./orderMaterialPreview.vue?vue&type=script&lang=js&"
import style0 from "./orderMaterialPreview.vue?vue&type=style&index=0&id=775fd553&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775fd553",
  null
  
)

export default component.exports